'use client';
const getElementVariantStyles = (theme, { color }, { variant })=>{
    const { primary, background, text } = theme.palette;
    const { themeColor, deriveShades } = theme.fn;
    const shades = deriveShades(themeColor(color, primary, {
        invariants: {
            neutral: (shades)=>({
                    base: shades[80],
                    min: shades[40]
                })
        }
    }));
    const baseShade = shades.base || shades[600];
    switch(variant){
        case 'light':
            {
                var _color_startsWith;
                if (color == null ? void 0 : (_color_startsWith = color.startsWith) == null ? void 0 : _color_startsWith.call(color, 'neutral')) {
                    return {
                        background: background.elementWeak,
                        text: text.medium
                    };
                }
                return {
                    background: shades.min || shades[50],
                    text: baseShade
                };
            }
        case 'default':
            {
                return {
                    background: baseShade,
                    text: background.content
                };
            }
        default:
            {
                return {
                    background: baseShade,
                    text: background.content
                };
            }
    }
};

export { getElementVariantStyles };
//# sourceMappingURL=getElementVariantStyles.js.map
